import { gql } from 'graphql-tag';

export const CREATE_CUSTOM_FIELD_VALUE = gql`
  mutation Id22d183bb3eeeca2b331aecb05d71545b(
    $customFieldId: ID!
    $value: String!
  ) {
    __typename
  }
`;
